import React, { useState } from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { Form } from 'providers/Forms';
import { state, sequences } from 'app/pwa/app.cerebral';

import {
  Wrapper,
  Title,
  DescriptionText,
  TextInput,
  SendButton,
  SpacerLine,
  NewUserText,
  RegisterButton,
  RegisterWrapper,
  Container,
  OtherButton,
  Form as FormElement,
} from './elements';
import AuthenticationError from '../../common/AuthenticationError';
import { useText, useLink } from 'common/hooks';

const deps = {
  form: state.appContainer.auth.forgotPasswordForm,
  creationNeeded: state.app.params.creationNeeded,
  isSendingEmail: state.account.isSendingPasswordEmail,
  fieldChanged: sequences`appContainer.fieldChanged`,
  forgotPasswordSubmitted: sequences`appContainer.auth.forgotPasswordSubmitted`,
};

export function ForgotPasswordForm({
  form,
  creationNeeded,
  isSendingEmail,
  fieldChanged,
  forgotPasswordSubmitted,
  get,
}: typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();
  const link = useLink();
  const [inputEnabled, setInputEnabled] = useState(true);
  const forgotPasswordForm = new Form(form, get) as any;

  return (
    <Container>
      <Wrapper>
        <Title as={'h1'}>
          {creationNeeded
            ? t('authentication.need_password')
            : t('authentication.lost_password')}
        </Title>
        <DescriptionText>
          {creationNeeded
            ? t('authentication.send_create_password_email')
            : t('authentication.send_forgot_password_email')}
        </DescriptionText>
        <AuthenticationError />
        <FormElement
          onSubmit={event => {
            event.preventDefault();
            forgotPasswordSubmitted();
            setInputEnabled(false);
          }}
        >
          <TextInput
            errorMessage={
              !forgotPasswordForm.email.isValid &&
              !forgotPasswordForm.email.isPristine &&
              t(
                forgotPasswordForm.email.errorMessage.phrase,
                forgotPasswordForm.email.errorMessage.options
              )
            }
            onBlur={event =>
              fieldChanged({
                field: 'appContainer.auth.forgotPasswordForm.email',
                value: event.target.value,
                touched: true,
              })
            }
            onChange={event =>
              fieldChanged({
                field: 'appContainer.auth.forgotPasswordForm.email',
                value: event.target.value,
              })
            }
            name={'email'}
            disabled={!inputEnabled}
            placeholder={t('appContainer.ModLogin.email')}
            value={forgotPasswordForm.email.value}
          />
          <SendButton disabled={!forgotPasswordForm.isValid || isSendingEmail}>
            {t('appContainer.ModLogin.send')}
          </SendButton>
        </FormElement>
        <OtherButton href={link('login')}>
          {t('authentication.use_another')}
        </OtherButton>
        <SpacerLine />
        <RegisterWrapper>
          <NewUserText>{t('authentication.new_user')}</NewUserText>
          <RegisterButton href={link('register')}>
            {t('appContainer.ModLogin.register')}
          </RegisterButton>
        </RegisterWrapper>
      </Wrapper>
    </Container>
  );
}

export default connect(deps, ForgotPasswordForm);
